module.exports = __webpack_public_path__ + "static/media/title.86f81667.png";